import { LIMITS } from './constants';

/**
 * Normalize a block title for writing and for the display grouping key (2026-10b §5.1):
 * line breaks collapse into single spaces, surrounding whitespace is removed, the length is
 * capped at `LIMITS.blockTitleMax`, and an empty result becomes null ("no title").
 */
export function normalizeBlockTitle(raw: string | null | undefined): string | null {
  if (raw === null || raw === undefined) return null;
  const flat = raw.replace(/\s*[\r\n]+\s*/g, ' ').trim();
  if (flat === '') return null;
  return flat.slice(0, LIMITS.blockTitleMax).trim();
}
